import React, { ChangeEvent, useEffect } from "react";
import IOrder_ItemUI from "../../../models/IOrder_ItemUI";
import OwCheckbox from "../../shared/OwCheckbox/OwCheckbox";
import OwLabel from "../../shared/OwLabel/OwLabel";
import OwInputWrapper from "../../shared/OwInputWrapper/OwInputWrapper";
import UIService from "../../../services/UIService";

export interface IRmaRow {
    orderItemGuid: string;
    order_line_item_id: number;
    catalog_item_id: number;
    isChecked: boolean;
    qty: number;
    maxQty: number;
    returnReasonId?: number;
    lineNotes?: string;
}

type Props = {
    data: IOrder_ItemUI;
    rmaRows: IRmaRow[];
    checkRowForRma: (orderItemGuid: string, isChecked: boolean, qty: number) => void;
};

export const OrderActionColRma = (props: Props) => {
    const getMaxQty = () => {
        let maxQty = 0;

        if (props.data.qty_on_rma) {
            maxQty = Number(props.data.qty) - Number(props.data.qty_on_rma);
        } else {
            maxQty = Number(props.data.qty);
        }

        return maxQty;
    };

    const [rmaRow, setRmaRow] = React.useState<IRmaRow>({
        isChecked: false,
        orderItemGuid: props.data.guid,
        order_line_item_id: props.data.id,
        catalog_item_id: props.data.catalog_item_id,
        qty: 0,
        maxQty: getMaxQty(),
    });

    const updateRmaRow = () => {
        if (props.rmaRows) {
            for (const row of props.rmaRows) {
                if (row.orderItemGuid === props.data.guid) {
                    setRmaRow(row);
                    return;
                }
            }
        }
    };

    useEffect(() => {
        updateRmaRow();
    }, []);

    const checkRowForRma = (e: ChangeEvent<any>) => {
        const value = e.target.type === "checkbox" ? e.target.checked : e.target.value;

        const _rmaRow = {
            ...rmaRow,
            isChecked: value,
            qty: value ? rmaRow.qty || rmaRow.maxQty : 0, // Set qty to max when checked, 0 when unchecked
        };

        setRmaRow(_rmaRow);
        props.checkRowForRma(props.data.guid, _rmaRow.isChecked, _rmaRow.qty);
    };

    const handleRmaQtyChange = (e: ChangeEvent<any>) => {
        const value = e.target.value;

        const _rmaRow = {
            ...rmaRow,
        };

        // Ensure qty is between 0 and maxQty
        let qty = Number(value);
        if (qty < 0) {
            qty = 0;
        }
        if (qty > rmaRow.maxQty) {
            qty = rmaRow.maxQty;
        }

        _rmaRow.qty = qty;

        setRmaRow(_rmaRow);
        props.checkRowForRma(props.data.guid, _rmaRow.isChecked, _rmaRow.qty);
    };

    return (
        <div className={"OrderActionColRma"}>
            <div className={"d-flex align-items-center"}>
                <OwCheckbox name={"orderItemGuid"} fn={checkRowForRma} truthyVal={true} falsyVal={false} checked={rmaRow.isChecked} />
                {!rmaRow.isChecked ? null : (
                    <div className={"mt-3 ms-2 min-w-10r d-flex flex-column align-items-start"}>
                        <div>
                            <OwLabel title={"return_qty"} noBottomMargin={true} className={"me-2"} />
                        </div>
                        <div className={"d-flex align-items-center mb-1"}>
                            <OwInputWrapper
                                name={"rmaQty"}
                                type={"number"}
                                value={rmaRow.qty}
                                fn={handleRmaQtyChange}
                                onWheelFn={UIService.stopScrollWheel}
                                min={0}
                                max={rmaRow.maxQty}
                            />
                        </div>
                        <div className={"text-small"}>
                            <OwLabel title={"max_qty"} postText={":"} className={"me-2"} />
                            {rmaRow.maxQty}
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};
